<template>
    <v-dialog persistent
              v-model="show"
              width="500px">
        <v-card>
            <v-card-title>New Invoice</v-card-title>
            <v-card-text>
                <v-row class="pb-0" no-gutters>
                    <v-col cols="12">
                        <v-select
                                :items="months"
                                label="Invoice Month"
                                v-model="selectedMonth"
                                :error="hasError"
                                :error-messages="errorMessage"
                                @change="reset"/>
                    </v-col>
                </v-row>
                <v-row class="pb-0" no-gutters>
                    <v-col cols="12">
                        <v-select
                            :items="years"
                            label="Invoice Year"
                            v-model="selectedYear"
                            @change="reset"/>
                    </v-col>
                </v-row>
                <v-row v-if="paymentPreference===2" class="pb-0">
                    <v-col cols="12">
                        <v-menu :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="showDatePicker">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                        label="Due Date"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        :rules="[requiredRule]"
                                        v-bind="attrs"
                                        v-model="dueDate"
                                        v-on="on"
                                        clearable
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    @input="showDatePicker = false"
                                    color="secondary"
                                    v-model="dueDate"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="close"
                       class="text-none"
                       color="secondary darken-1"
                       text
                       v-if="!isLoading">Close
                </v-btn>
                <v-spacer></v-spacer>
                <v-chip
                        v-if="isLoading"
                        color="blue"
                >Creating Invoice, please wait...
                </v-chip>
                <v-btn :disabled="isLoading || !selectedMonth"
                       :loading="isLoading"
                       @click="createInvoice"
                       class="text-none"
                       color="secondary darken-1"
                       text>Create
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import invoiceService from '@/services/invoice.service.js';

export default {
    props: ['companyId', 'show', 'paymentPreference'],
    name: "CompanyInvoiceAddDialog",
    data() {
        return {
            months: [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ],
            years: [],
            selectedMonth: null, //new Intl.DateTimeFormat('en-ZA', { month: 'long' }).format(new Date),
            selectedYear: null,
            hasError: false,
            errorMessage: null,
            isLoading: false,
            invoiceDate: null,
            dueDate: this.$moment(new Date()).format("YYYY-MM-DD"),
            showDatePicker: false,
            requiredRule: (v) => !!v || "required",
        }
    },
    methods: {
        async createInvoice() {
            this.isLoading = true;
            try {
                const month = this.$moment().month(this.selectedMonth).month();
                this.invoiceDate = new Date(this.selectedYear, month, 1);
                console.log(this.invoiceDate);

                await invoiceService.create(this.companyId,
                    this.$moment(this.invoiceDate).format("YYYY-MM-DD"),
                    this.$moment(this.dueDate).format("YYYY-MM-DD"));
                this.$emit('invoice-created');
            } catch (e) {
                this.errorMessage = e.response.data.error;
                this.hasError = true;
            }
            this.selectedYear = null;
            this.selectedMonth = null;
            this.isLoading = false;
        },
        close() {
            this.reset();
            this.$emit('close');
        },
        reset() {
            //this.selectedYear = new Date().getFullYear();
            //this.selectedMonth = new Intl.DateTimeFormat('en-ZA', { month: 'long' }).format(new Date);

            this.hasError = false;
            this.errorMessage = null;
        },
        getYears(){
            const currentYear = new Date().getFullYear();
            const pastYear = currentYear - 5;
            const futureYear = currentYear + 5;
            this.years = [];
            for (let year = pastYear; year <= futureYear; year++) {
                this.years.push(year);
            }
            //this.selectedYear = currentYear;
        }
    },
    created() {
        this.getYears();
    },
}
</script>

<style scoped>

</style>
